/* ASURA — ficha olfativa: el mando de "en la piel"
   Recorre los momentos del perfume (salida, corazón, fondo). Los colores se
   funden de forma continua con el mando; las notas cambian al pasar de la mitad.
   Sin este archivo los momentos se ven apilados (snippets/asura-ficha.liquid). */
(function () {
  function iniciar(piel) {
    var escenas = [].slice.call(piel.querySelectorAll('[data-asura-escena]'));
    var mando = piel.querySelector('[data-asura-mando]');
    if (piel.hasAttribute('data-asura-lista') || !mando || escenas.length < 2) return;
    piel.setAttribute('data-asura-lista', '');

    var control = mando.querySelector('input[type="range"]');
    var paradas = mando.querySelector('[data-asura-paradas]');
    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ultima = escenas.length - 1;
    var tocado = false;
    var cuadro = 0;

    // los fondos van a una capa común para poder fundirse entre sí
    var capa = document.createElement('div');
    capa.className = 'asura-piel__fondos';
    capa.setAttribute('aria-hidden', 'true');
    var fondos = escenas.map(function (escena) {
      var fondo = escena.querySelector('.asura-piel__fondo');
      fondo.style.cssText = escena.getAttribute('style') || '';
      capa.appendChild(fondo);
      return fondo;
    });
    piel.insertBefore(capa, piel.firstChild);

    var botones = escenas.map(function (escena, i) {
      var boton = document.createElement('button');
      boton.type = 'button';
      boton.className = 'asura-piel__parada';
      boton.textContent = escena.getAttribute('data-momento');
      boton.addEventListener('click', function () {
        tocado = true;
        irA(i);
      });
      paradas.appendChild(boton);
      return boton;
    });

    function pintar() {
      var x = (Number(control.value) / 100) * ultima;
      var base = Math.min(Math.floor(x), ultima);
      var activa = Math.round(x);
      escenas.forEach(function (escena, i) {
        var visible = i === base ? 1 : i === base + 1 ? x - base : 0;
        fondos[i].style.setProperty('--fondo', visible.toFixed(3));
        escena.classList.toggle('is-activa', i === activa);
        escena.setAttribute('aria-hidden', i === activa ? 'false' : 'true');
        botones[i].classList.toggle('is-activa', i === activa);
        botones[i].setAttribute('aria-pressed', i === activa ? 'true' : 'false');
      });
      control.setAttribute('aria-valuetext', escenas[activa].getAttribute('data-momento'));
      control.style.setProperty('--avance', Number(control.value).toFixed(2) + '%');
    }

    function irA(indice) {
      var destino = (Math.max(0, Math.min(ultima, indice)) / ultima) * 100;
      var desde = Number(control.value);
      var inicio = null;
      cancelAnimationFrame(cuadro);
      if (quieto || desde === destino) {
        control.value = destino;
        pintar();
        return;
      }
      cuadro = requestAnimationFrame(function paso(ahora) {
        if (inicio === null) inicio = ahora;
        var k = Math.min((ahora - inicio) / 380, 1);
        control.value = desde + (destino - desde) * (1 - Math.pow(1 - k, 3));
        pintar();
        if (k < 1) cuadro = requestAnimationFrame(paso);
      });
    }

    function masCercana() {
      return Math.round((Number(control.value) / 100) * ultima);
    }

    control.addEventListener('input', function () {
      tocado = true;
      cancelAnimationFrame(cuadro);
      pintar();
    });

    // al soltar, el mando descansa en el momento más cercano
    ['pointerup', 'touchend', 'mouseup'].forEach(function (evento) {
      control.addEventListener(evento, function () {
        irA(masCercana());
      });
    });

    // con teclado se avanza de momento en momento
    control.addEventListener('keydown', function (e) {
      var paso = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1 }[e.key];
      var destino = e.key === 'Home' ? 0 : e.key === 'End' ? ultima : paso ? masCercana() + paso : null;
      if (destino === null) return;
      e.preventDefault();
      tocado = true;
      irA(destino);
    });

    piel.classList.add('is-viva');
    mando.hidden = false;
    pintar();

    // una sola seña, la primera vez que el mando entra en pantalla
    if (!quieto && 'IntersectionObserver' in window) {
      var ojo = new IntersectionObserver(
        function (entradas) {
          if (!entradas[0].isIntersecting) return;
          ojo.disconnect();
          var inicio = null;
          var tope = (100 / ultima) * 0.44;
          cuadro = requestAnimationFrame(function paso(ahora) {
            if (tocado) return;
            if (inicio === null) inicio = ahora;
            var k = Math.min((ahora - inicio) / 1500, 1);
            control.value = Math.sin(k * Math.PI) * tope;
            pintar();
            if (k < 1) cuadro = requestAnimationFrame(paso);
          });
        },
        { threshold: 1 }
      );
      ojo.observe(control);
    }
  }

  function todas() {
    [].forEach.call(document.querySelectorAll('[data-asura-piel]'), iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todas);
  } else {
    todas();
  }
  document.addEventListener('shopify:section:load', todas);
})();

/* ASURA — la frase del perfume se llena con sus colores
   Cuando la frase entra en pantalla, cada verso pasa de gris a los colores del
   perfume, de izquierda a derecha y en el orden en que se lee. Una sola vez.
   Sin este archivo, o con movimiento reducido, la frase ya se ve llena. */
(function () {
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (quieto || !('IntersectionObserver' in window) || !window.requestAnimationFrame) return;

  var DURACION = 900;
  var PAUSA = 120;

  function llenar(versos) {
    var inicio = null;
    requestAnimationFrame(function paso(ahora) {
      if (inicio === null) inicio = ahora;
      var listo = true;
      versos.forEach(function (verso, i) {
        var x = (ahora - inicio - i * (DURACION + PAUSA)) / DURACION;
        x = Math.max(0, Math.min(1, x));
        if (x < 1) listo = false;
        var suave = x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
        verso.style.setProperty('--p', (suave * 100).toFixed(2) + '%');
      });
      if (!listo) requestAnimationFrame(paso);
    });
  }

  function preparar(retrato) {
    if (retrato.hasAttribute('data-asura-lista')) return;
    retrato.setAttribute('data-asura-lista', '');
    var versos = [].slice.call(retrato.querySelectorAll('.asura-retrato__verso'));
    if (!versos.length) return;

    versos.forEach(function (verso) { verso.style.setProperty('--p', '0%'); });
    var ojo = new IntersectionObserver(function (entradas) {
      if (!entradas[0].isIntersecting) return;
      ojo.disconnect();
      llenar(versos);
    }, { threshold: 0.6 });
    ojo.observe(retrato);
  }

  function todas() {
    [].forEach.call(document.querySelectorAll('[data-asura-retrato]'), preparar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todas);
  } else {
    todas();
  }
  document.addEventListener('shopify:section:load', todas);
})();
